import { PropsWithChildren } from 'react';
import { colors, s4 } from '@ardoq/design-tokens';
import styled from 'styled-components';
import {
  DragAndDropCardWrapper,
  DragAndDropSectionProps,
} from '@ardoq/drag-and-drop';
import { DRAG_BUTTON_CLASS_NAME } from '@ardoq/icons';
import { ColorBar, IslandHeaderProps, IslandHeader } from '@ardoq/page-layout';

const IslandDragAndDropCardWrapper = styled(DragAndDropCardWrapper)`
  flex: 1;
  align-items: center;
  width: 100%;
  .${DRAG_BUTTON_CLASS_NAME} {
    padding-left: ${s4};
  }
`;

const BorderWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid ${colors.borderAction};
  cursor: pointer;
  &:only-child {
    border-bottom: 0;
  }
`;

type ClickableIslandHeaderProps = {
  onClick: () => void;
} & IslandHeaderProps &
  DragAndDropSectionProps;

export const ClickableIslandHeader = ({
  barColor,
  dragAndDropCardId,
  onClick,
  children,
  ...headerProps
}: PropsWithChildren<ClickableIslandHeaderProps>) => (
  <BorderWrapper onClick={onClick} data-test-id="expand-island-header-button">
    {barColor && <ColorBar $barColor={barColor} />}
    <IslandDragAndDropCardWrapper
      dragAndDropCardId={dragAndDropCardId}
      dragButtonAlwaysVisible
      dragButtonPosition="left"
    >
      <IslandHeader {...headerProps}>{children}</IslandHeader>
    </IslandDragAndDropCardWrapper>
  </BorderWrapper>
);
